import request from '@/utils/request'

// 查询特种设备通知公告列表
export function listTzsbTzgg(query) {
  return request({
    url: '/web/jyjcfw/tzsbTzgg/list',
    method: 'get',
    params: query
  })
}

// 查询特种设备通知公告详细
export function getTzsbTzgg(recid) {
  return request({
    url: '/web/jyjcfw/tzsbTzgg/' + recid,
    method: 'get'
  })
}